import StoreSpecialSchedule from "@components/Stores/StoreSpecialSchedule";
import { getStoreCombinedSchedule } from "@lib/helpers";

const StoreSchedule = ({ schedule, special_schedule }) => (
  <div className="mt-3">
    {special_schedule && Object.keys(special_schedule).length !== 0 && (
      <div className="mb-4 text-red-brand">
        <StoreSpecialSchedule schedule={special_schedule} />
      </div>
    )}

    {schedule &&
      schedule.length !== 0 &&
      getStoreCombinedSchedule(schedule).map((day, index) => (
        <div className="flex" key={index}>
          <span className="font-medium mr-1">
            {day.endDay
              ? `${day.startDay} — ${day.endDay}: `
              : `${day.startDay}: `}
          </span>
          {day.openHours}
        </div>
      ))}
  </div>
);

export default StoreSchedule;
